// Standard banner imports
import jobBanner1 from "@/assets/job-banner-1.jpg";
import jobBanner2 from "@/assets/job-banner-2.jpg";
import jobBanner3 from "@/assets/job-banner-3.jpg";
import jobBanner4 from "@/assets/job-banner-4.jpg";
import jobBanner5 from "@/assets/job-banner-5.jpg";
import jobBannerEnergy1 from "@/assets/job-banner-energy-1.jpg";
import jobBannerEnergy2 from "@/assets/job-banner-energy-2.jpg";
import jobBannerSustainable from "@/assets/job-banner-sustainable.jpg";
import jobBannerRemote from "@/assets/job-banner-remote.jpg";
import jobBannerInnovation from "@/assets/job-banner-innovation.jpg";
import jobBannerDiversity from "@/assets/job-banner-diversity.jpg";
import jobBannerLearning from "@/assets/job-banner-learning.jpg";
import jobBannerCreative from "@/assets/job-banner-creative.jpg";
import jobBannerYouthTeam from "@/assets/job-banner-youth-team.jpg";
import jobBannerHospitality from "@/assets/job-banner-hospitality.jpg";
import jobBannerRetail from "@/assets/job-banner-retail.jpg";
import jobBannerEvents from "@/assets/job-banner-events.jpg";
import jobBannerConstruction from "@/assets/job-banner-construction.jpg";
import jobBannerHealthcare from "@/assets/job-banner-healthcare.jpg";
import jobBannerLogistics from "@/assets/job-banner-logistics.jpg";
import jobBannerKitchen from "@/assets/job-banner-kitchen.jpg";
import jobBannerMarketing from "@/assets/job-banner-marketing.jpg";
import jobBannerTechTeam from "@/assets/job-banner-tech-team.jpg";
import jobBannerEducation from "@/assets/job-banner-education.jpg";
import jobBannerBarista from "@/assets/job-banner-barista.jpg";
import jobBannerCollab1 from "@/assets/job-banner-collab-1.jpg";
import jobBannerCollab2 from "@/assets/job-banner-collab-2.jpg";
import jobBannerCollab3 from "@/assets/job-banner-collab-3.jpg";
import jobBannerCollab4 from "@/assets/job-banner-collab-4.jpg";
import jobBannerHospitality2 from "@/assets/job-banner-hospitality-2.jpg";
import jobBannerHospitality3 from "@/assets/job-banner-hospitality-3.jpg";
import jobBannerRetail2 from "@/assets/job-banner-retail-2.jpg";
import jobBannerRetail3 from "@/assets/job-banner-retail-3.jpg";
import jobBannerConstruction2 from "@/assets/job-banner-construction-2.jpg";
import jobBannerLogistics2 from "@/assets/job-banner-logistics-2.jpg";
import jobBannerHealthcare2 from "@/assets/job-banner-healthcare-2.jpg";
import jobBannerEducation2 from "@/assets/job-banner-education-2.jpg";
import jobBannerTech2 from "@/assets/job-banner-tech-2.jpg";
import jobBannerCreative2 from "@/assets/job-banner-creative-2.jpg";
import jobBannerProfessional2 from "@/assets/job-banner-professional-2.jpg";
import jobBannerAesthetic1 from "@/assets/job-banner-aesthetic-1.jpg";
import jobBannerAestheticCafe from "@/assets/job-banner-aesthetic-cafe.jpg";
import jobBannerAestheticRetail from "@/assets/job-banner-aesthetic-retail.jpg";
import jobBannerAestheticKitchen from "@/assets/job-banner-aesthetic-kitchen.jpg";
import jobBannerAestheticOffice from "@/assets/job-banner-aesthetic-office.jpg";
import jobBannerAestheticWarehouse from "@/assets/job-banner-aesthetic-warehouse.jpg";
import jobBannerAestheticStudio from "@/assets/job-banner-aesthetic-studio.jpg";
import jobBannerAestheticWellness from "@/assets/job-banner-aesthetic-wellness.jpg";
import jobBannerRetailStaff1 from "@/assets/job-banner-retail-staff-1.jpg";
import jobBannerRetailStaff2 from "@/assets/job-banner-retail-staff-2.jpg";
import jobBannerRetailStaff3 from "@/assets/job-banner-retail-staff-3.jpg";
import jobBannerAdmin1 from "@/assets/job-banner-admin-1.jpg";
import jobBannerAdmin2 from "@/assets/job-banner-admin-2.jpg";
import jobBannerAdmin3 from "@/assets/job-banner-admin-3.jpg";
import jobBannerPhoto from "@/assets/job-banner.jpg";
import defaultBlueAsset from "@/assets/job-banner-default-blue.jpg.asset.json";
import defaultFlatAsset from "@/assets/job-banner-default-flat.jpg.asset.json";
import defaultRadarAsset from "@/assets/job-banner-default-radar.jpg.asset.json";

// Standaard vacaturebanner: ChillWerk-blauw met dunne radarringen (familie van de kandidaatbanner).
// Alleen voor vacatures; kandidaat- en bedrijfsbanners staan hier los van.
const jobBanner = defaultRadarAsset.url;

// Map of banner IDs to their imported URLs
export const standardBanners: Record<string, string> = {
  "banner-default": jobBanner,
  "banner-radar-default": defaultRadarAsset.url,
  "banner-gradient-default": defaultBlueAsset.url,
  "banner-flat-default": defaultFlatAsset.url,
  "banner-photo-default": jobBannerPhoto,

  "banner1": jobBanner1,
  "banner2": jobBanner2,
  "banner3": jobBanner3,
  "banner4": jobBanner4,
  "banner5": jobBanner5,
  "banner-energy1": jobBannerEnergy1,
  "banner-energy2": jobBannerEnergy2,
  "banner-sustainable": jobBannerSustainable,
  "banner-remote": jobBannerRemote,
  "banner-innovation": jobBannerInnovation,
  "banner-diversity": jobBannerDiversity,
  "banner-learning": jobBannerLearning,
  "banner-creative": jobBannerCreative,
  "banner-youth-team": jobBannerYouthTeam,
  "banner-hospitality": jobBannerHospitality,
  "banner-retail": jobBannerRetail,
  "banner-events": jobBannerEvents,
  "banner-construction": jobBannerConstruction,
  "banner-healthcare": jobBannerHealthcare,
  "banner-logistics": jobBannerLogistics,
  "banner-kitchen": jobBannerKitchen,
  "banner-marketing": jobBannerMarketing,
  "banner-tech-team": jobBannerTechTeam,
  "banner-education": jobBannerEducation,
  "banner-barista": jobBannerBarista,
  "banner-collab-1": jobBannerCollab1,
  "banner-collab-2": jobBannerCollab2,
  "banner-collab-3": jobBannerCollab3,
  "banner-collab-4": jobBannerCollab4,
  "banner-hospitality-2": jobBannerHospitality2,
  "banner-hospitality-3": jobBannerHospitality3,
  "banner-retail-2": jobBannerRetail2,
  "banner-retail-3": jobBannerRetail3,
  "banner-construction-2": jobBannerConstruction2,
  "banner-logistics-2": jobBannerLogistics2,
  "banner-healthcare-2": jobBannerHealthcare2,
  "banner-education-2": jobBannerEducation2,
  "banner-tech-2": jobBannerTech2,
  "banner-creative-2": jobBannerCreative2,
  "banner-professional-2": jobBannerProfessional2,
  "banner-aesthetic-1": jobBannerAesthetic1,
  "banner-aesthetic-cafe": jobBannerAestheticCafe,
  "banner-aesthetic-retail": jobBannerAestheticRetail,
  "banner-aesthetic-kitchen": jobBannerAestheticKitchen,
  "banner-aesthetic-office": jobBannerAestheticOffice,
  "banner-aesthetic-warehouse": jobBannerAestheticWarehouse,
  "banner-aesthetic-studio": jobBannerAestheticStudio,
  "banner-aesthetic-wellness": jobBannerAestheticWellness,
  "banner-retail-staff-1": jobBannerRetailStaff1,
  "banner-retail-staff-2": jobBannerRetailStaff2,
  "banner-retail-staff-3": jobBannerRetailStaff3,
  "banner-admin-1": jobBannerAdmin1,
  "banner-admin-2": jobBannerAdmin2,
  "banner-admin-3": jobBannerAdmin3,
};

// Map old asset paths to banner IDs for migration
const assetPathToBannerId: Record<string, string> = {
  "/src/assets/job-banner-1.jpg": "banner1",
  "/src/assets/job-banner-2.jpg": "banner2",
  "/src/assets/job-banner-3.jpg": "banner3",
  "/src/assets/job-banner-4.jpg": "banner4",
  "/src/assets/job-banner-5.jpg": "banner5",
  "/src/assets/job-banner-energy-1.jpg": "banner-energy1",
  "/src/assets/job-banner-energy-2.jpg": "banner-energy2",
  "/src/assets/job-banner-sustainable.jpg": "banner-sustainable",
  "/src/assets/job-banner-remote.jpg": "banner-remote",
  "/src/assets/job-banner-innovation.jpg": "banner-innovation",
  "/src/assets/job-banner-diversity.jpg": "banner-diversity",
  "/src/assets/job-banner-learning.jpg": "banner-learning",
  "/src/assets/job-banner-creative.jpg": "banner-creative",
};

/**
 * Resolves a banner URL from the database to an actual displayable URL.
 */
export function resolveBannerUrl(bannerUrl: string | null | undefined): string {
  if (!bannerUrl) return jobBanner;
  if (standardBanners[bannerUrl]) return standardBanners[bannerUrl];

  if (bannerUrl.startsWith("/src/assets/")) {
    const bannerId = assetPathToBannerId[bannerUrl];
    if (bannerId && standardBanners[bannerId]) return standardBanners[bannerId];
    return jobBanner;
  }

  if (bannerUrl.startsWith("http://") || bannerUrl.startsWith("https://")) {
    return bannerUrl;
  }

  if (bannerUrl.startsWith("/assets/")) return bannerUrl;

  return jobBanner;
}

export const defaultBanner = jobBanner;

/** True when the shown banner is the flat standard banner (not a photo), so no readability shade is needed. */
export function isFlatDefaultBanner(bannerUrl: string | null | undefined): boolean {
  const resolved = resolveBannerUrl(bannerUrl);
  return resolved === jobBanner || resolved === defaultBlueAsset.url || resolved === defaultFlatAsset.url;
}
